import React from 'react';
export default class RowItemListOrganizationPeriodical extends React.Component {

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.coQuanDonViInfo ? this.props.item.coQuanDonViInfo.ten : ''}</td>
        <td>{this.props.item.nguoiDaiDien}</td>
        <td>{this.props.item.chucVu}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/datatable/detail/RowItemListOrganizationPeriodical.jsx